import { useGetETSTicketQuery } from 'gcs-common/clients/api/entities/tickets/tickets-api';
import { CHAT_ROUTES } from 'gcs-common/constants/routes';
import { useLocation, useParams } from 'react-router-dom';
import TicketAttachmentThumbnail from '../TicketAttachmentThumbnail/TicketAttachmentThumbnail';
import TicketItemSkeleton from '../TicketItemSkeleton/TicketItemSkeleton';
import TicketStatus from '../TicketStatus/TicketStatus';

const TicketHeader = () => {
  const { routeTicketId } = useParams();
  const location = useLocation();
  const ticketId = routeTicketId ?? '';
  const { data: ticket, isLoading } = useGetETSTicketQuery({ path: { ticket_id: ticketId || '' } });
  if (isLoading) {
    return <TicketItemSkeleton />;
  }
  if (ticketId) {
    return (
      <div className="flex w-full items-center gap-3">
        <TicketAttachmentThumbnail thumbnail={ticket?.previewImageUrl || ''} />
        <div className="flex flex-col">
          <span className="text-ellipsis text-base text-neutral-12">{ticket?.title || 'Kein Titel'}</span>
          <div className="flex flex-row items-center gap-2">
            <TicketStatus status={ticket?.status || 'sent'} />
            <span className="text-neutral-11 text-sm">
              Ersatzteilanfrage{ticket ? ` \u2022 ${ticket?.externalJiraKey}` : ''}
            </span>
          </div>
        </div>
      </div>
    );
  }
  if (location.pathname === CHAT_ROUTES.NEW_TICKET) {
    return (
      <div className="m-auto">
        <span className="truncate font-medium text-base text-neutral-12">Neue Ersatzteilanfrage</span>
      </div>
    );
  }
};

export default TicketHeader;
